var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classification"},[_c('div',{staticClass:"header"},[_c('el-form',{ref:"formTool",staticStyle:{"text-align":"left"},attrs:{"model":_vm.formTool,"inline":true}},[_c('el-form-item',[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.download()}}},[_vm._v("完税证明下载")])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }